export default "__VITE_ASSET__VOWv8OSKRfIIh24rTBNP3Q__"